import axios from "axios";
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
    {
        path: '*/campaign/:campaign_slug/:campaign_id',
        name: 'Campaign',
        component: () => import(/* webpackChunkName: "about" */ '../views/Campaign.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '*/campaign/:campaign_slug/:campaign_id/thank-you',
        name: 'ThankYou',
        component: () => import(/* webpackChunkName: "about" */ '../views/ThankYou.vue'),
        meta: {
            requiresThankYouAuth: true
        }
    },
    {
        path: '*/campaign/:campaign_slug/:campaign_id/ended',
        name: 'Ended',
        component: () => import(/* webpackChunkName: "about" */ '../views/Ended.vue')
    },
    {
        path: '*/campaign/:campaign_slug/:campaign_id/pending',
        name: 'Pending',
        component: () => import(/* webpackChunkName: "about" */ '../views/Pending.vue')
    },
    {
        path: '*',
        name: '404',
        component: () => import(/* webpackChunkName: "about" */ '../views/404.vue')
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_BASE_PATH,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresThankYouAuth)) {
        let campaign_id = to.params.campaign_id
        let thankYouSource = sessionStorage.getItem('thankYouSource_' + campaign_id)

        if (thankYouSource !== 'submit') {
            next({
                name: 'Campaign',
                params: {
                    campaign_slug: to.params.campaign_slug,
                    campaign_id: campaign_id
                }
            })
        } else {
            sessionStorage.removeItem('thankYouSource_' + campaign_id)
            next()
        }
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
        let campaign_id = to.params.campaign_id

        axios
            .post( process.env.VUE_APP_API_PATH +"/campaignStatus/"+ campaign_id)
            .then(response => {
                let res = response.data;

                if(res == 'Not Found'){
                    next({
                        name: '404'
                    })
                }else if(res == 'Completed'){
                    let endedPath = process.env.VUE_APP_BASE_PATH + 'campaign/' + to.params.campaign_slug + '/' + campaign_id + '/ended'
                    window.location.href = endedPath
                }else if(res == 'Pending'){
                    let pendingPath = process.env.VUE_APP_BASE_PATH + 'campaign/' + to.params.campaign_slug + '/' + campaign_id + '/pending'
                    window.location.href = pendingPath
                }else{
                    next()
                }

            });

    } else {
        next()
    }
})

export default router
